import { ManagedChannelListOrderBy } from "generated/CoreApi_v1";
import React, { PropsWithChildren, useState } from "react";
import { Outlet } from "react-router";
import { IAdvFilterParams } from "views/general/AdvancedFilter";

////////////////////////////////////////////////////////////////////////////////

export interface ChannelListFilter extends IAdvFilterParams<ManagedChannelListOrderBy> {
    includeChannelsAdminPermission: boolean;
}

type ChannelListPagination = {
    page: number;
};

type ChannelContextType = {
    filter: ChannelListFilter;
    setFilter: (data: Partial<ChannelListFilter>) => void;
    resetFilter: () => void;
    pagination: ChannelListPagination;
    setPagination: (data: ChannelListPagination) => void;
    expandedAdvFilter: boolean;
    setExpandedAdvFilter: (data: boolean) => void;
};

const ChannelContext = React.createContext<ChannelContextType>(undefined!);

////////////////////////////////////////////////////////////////////////////////

export const useChannelManagementContext = () => React.useContext(ChannelContext);

////////////////////////////////////////////////////////////////////////////////

const ChannelManagementWrapper: React.FC<PropsWithChildren> = () => {
    const [filter, setFilter] = useState<ChannelListFilter>({ searchText: "", advFilters: [], order: ManagedChannelListOrderBy.Name, includeChannelsAdminPermission: false });
    const [pagination, setPagination] = useState<ChannelListPagination>({ page: 1 });
    const [expandedAdvFilter, setExpandedAdvFilter] = useState<boolean>(false);

    const resetFilter = () => {
        setFilter(state => ({ ...state, searchText: "", advFilters: [], includeChannelsAdminPermission: false }));
        setPagination({ page: 1 });
        setExpandedAdvFilter(false);
    };

    return (
        <ChannelContext.Provider
            value={
                {
                    filter,
                    setFilter: (data: Partial<ChannelListFilter>) => setFilter(state => ({ ...state, ...data })),
                    resetFilter,
                    pagination,
                    setPagination: (data: ChannelListPagination) => setPagination(data),
                    expandedAdvFilter,
                    setExpandedAdvFilter
                }
            }
        >
            <Outlet />
        </ChannelContext.Provider>
    );
};

export default ChannelManagementWrapper;